/**
 * LISTADO DE ENDPOINTS API CASOS https://apicasosdev.azurewebsites.net
 */
const URL_API_CASO = {
    // 📌 ALERTAS
    /**
     * AlertasLeidas ENDPOINT de API CASOS
     * Método: POST
     * Descripción: Marca un conjunto de alertas como leídas.
     */
    ALERTAS_LEIDAS: `${import.meta.env.VITE_API_CASO}/api/Alertas/AlertasLeidas`,

    /**
     * AlertaLeida ENDPOINT de API CASOS
     * Método: POST
     * Descripción: Marca una alerta individual como leída.
     */
    ALERTA_LEIDA: `${import.meta.env.VITE_API_CASO}/api/Alertas/AlertaLeida`,

    /**
     * LimpiarAlertas ENDPOINT de API CASOS
     * Método: POST
     * Descripción: Limpia todas las alertas de un usuario.
     */
    LIMPIAR_ALERTAS: `${import.meta.env.VITE_API_CASO}/api/Alertas/LimpiarAlertas`,

    /**
     * Obtener preferencias de notificación
     * Método: GET
     * Descripción: Recupera las preferencias de un usuario para un destinatario (Personal/Entidad).
     * Query Params: idUsuario, idDestinatario
     */
    OBTENER_PREFERENCIAS: `${import.meta.env.VITE_API_CASO}/api/Alertas/preferencias`,

    /**
     * Actualizar una preferencia (unitaria)
     * Método: PUT
     * Descripción: Actualiza el estado de notificación de una actividad específica.
     * Query Params: idUsuario, idDestinatario, idTipoActividad, notificacionSistema, notificacionEmail, idUsuarioSesion
     */
    ACTUALIZAR_PREFERENCIA: `${import.meta.env.VITE_API_CASO}/api/Alertas/preferencias`,

    /**
     * Actualizar múltiples preferencias
     * Método: POST
     * Descripción: Actualiza el estado de notificación de varias actividades a la vez.
     * Body: { idUsuario, idDestinatario, idUsuarioSesion, preferencias: [...] }
     */
    ACTUALIZAR_MULTIPLES_PREFERENCIAS: `${import.meta.env.VITE_API_CASO}/api/Alertas/preferencias/multiples`,

    // 📌 CASOS - RECEPCIÓN
    /**
     * CrearRecepcion ENDPOINT de API CASOS
     * Método: POST
     * Descripción: Crea una nueva recepción de documentos o caso.
     */
    CREAR_RECEPCION: `${import.meta.env.VITE_API_CASO}/api/casos/CrearRecepcion`,

    /**
     * EditarRecepcion ENDPOINT de API CASOS
     * Método: PUT
     * Descripción: Edita la información de una recepción.
     */
    EDITAR_RECEPCION: `${import.meta.env.VITE_API_CASO}/api/casos/EditarRecepcion`,

    /**
     * EliminarRecepcion ENDPOINT de API CASOS
     * Método: DELETE
     * Descripción: Elimina una recepción por GUID.
     */
    ELIMINAR_RECEPCION: `${import.meta.env.VITE_API_CASO}/api/casos/EliminarRecepcion`,

    /**
     * CompletarRecepcion ENDPOINT de API CASOS
     * Método: POST
     * Descripción: Completa una recepción previamente creada.
     */
    COMPLETAR_RECEPCION: `${import.meta.env.VITE_API_CASO}/api/casos/CompletarRecepcion`,

    // 📌 CASOS - INMUEBLES
    /**
     * AgregarInmueble ENDPOINT de API CASOS
     * Método: POST
     * Descripción: Agrega un inmueble asociado a un trámite/caso.
     */
    AGREGAR_INMUEBLE: `${import.meta.env.VITE_API_CASO}/api/casos/AgregarInmueble`,

    /**
     * EditarInmueble ENDPOINT de API CASOS
     * Método: PUT
     * Descripción: Edita la información de un inmueble.
     */
    EDITAR_INMUEBLE: `${import.meta.env.VITE_API_CASO}/api/casos/EditarInmueble`,

    /**
     * EliminarInmueble ENDPOINT de API CASOS
     * Método: PUT
     * Descripción: Elimina un inmueble asociado a un caso.
     */
    ELIMINAR_INMUEBLE: `${import.meta.env.VITE_API_CASO}/api/casos/EliminarInmueble`,

    /**
     * ObtenerTitularesInmueblePorIdInmueble ENDPOINT de API CASOS
     * Método: GET
     * Descripción: Obtiene los titulares de un inmueble usando el idInmueble.
     */
    OBTENER_TITULARES_INMUEBLE: `${import.meta.env.VITE_API_CASO}/api/casos/ObtenerTitularesInmueblePorIdInmueble`,

    /**
     * ObtenerTitularesInmueblePorIdTramiteInmueble ENDPOINT de API CASOS
     * Método: GET
     * Descripción: Obtiene los titulares de un inmueble filtrados por trámite.
     */
    OBTENER_TITULARES_INMUEBLE_TRAMITE: `${import.meta.env.VITE_API_CASO}/api/casos/ObtenerTitularesInmueblePorIdTramiteInmueble`,

    // 📌 CASOS - OTROS
    /**
     * SetAliasCaso ENDPOINT de API CASOS
     * Método: POST
     * Descripción: Asigna un alias a un caso.
     */
    SET_ALIAS_CASO: `${import.meta.env.VITE_API_CASO}/api/casos/SetAliasCaso`,

    /**
     * AsociarMiembroAlCaso ENDPOINT de API CASOS
     * Método: POST
     * Descripción: Asocia miembros (usuarios) a un caso.
     */
    ASOCIAR_MIEMBRO_CASO: `${import.meta.env.VITE_API_CASO}/api/casos/Asociarmiembrosalcaso`,

    /**
     * ReporteCaratula ENDPOINT de API CASOS
     * Método: POST
     * Descripción: Genera el reporte de carátula de un caso/trámite.
     */
    REPORTE_CARATULA: `${import.meta.env.VITE_API_CASO}/api/casos/ReporteCaratula`,

    /**
     * ValidarVerificacion ENDPOINT de API CASOS
     * Método: POST
     * Descripción: El endpoint ValidarVerificacion replica toda la lógica contenida en el método JavaScript validateVerificacion del frontend (formNuevoTramite.js:2768). 
     * Este endpoint centraliza la validación y procesamiento de verificación de depósitos judiciales, incluyendo la asignación de salas, asociación de miembros 
     * y envío de notificaciones.
     */
    VALIDAR_VERIFICACION: `${import.meta.env.VITE_API_CASO}/api/casos/ValidarVerificacion`,

    /**
     * CrearRecepcion ENDPOINT de API CASOS
     * Método: POST
     * Descripción: Crea una nueva recepción de documentos o trámite y genera la carátula.      
     */
    CREAR_RECEPCION_CON_CARATULA: `${import.meta.env.VITE_API_CASO}/api/casos/v2/CrearRecepcion`,
};

export default URL_API_CASO;